import React from 'react';
import { Label } from '../atoms/label';
import { Link } from '../atoms/link';

export const GolfSoloWeeksDate = (props) => {
    const {
        data,
        data2,
        onClickPlan,
        onClick
    } = props;

    const cols = data.map((value, index) =>
        <th key={'col1' + index} className={value.color == "black" ? "soloSearch_tdStyleBlack" : (value.color == "red" ? "soloSearch_tdStyleRed" : "soloSearch_tdStyleBlue")}>
            <Label label={value.day} className="soloSearch_calendarDate" />
            <Label label={value.week} className="soloSearch_calendarDay" />
        </th>
    );
    const cols2 = data2.map(plan =>
        <tr>
            <td key={plan.planId} className="soloSearch_planNameCol" onClick={() => onClickPlan(plan.planId, plan.planName)}>
                <Label label={plan.planName} className="soloSearch_planNameLabel" />
            </td>
            {plan.vacancyList?.map((vacancy, vacancyIndex) =>
                <td key={plan.planId + "_" + vacancyIndex} className={vacancy.vacancy != 0 ? "soloSearch_vacancyCol" : "soloSearch_vacancyColGray"}>
                    <Link linkTitle={vacancy.vacancy} className={vacancy.vacancy != 0 ? "soloSearch_vacancyNumLink" : ""} onClick={vacancy.vacancy != 0 ? () => { onClick(plan.planId, plan.planName, vacancy.date) } : null} />
                </td>
            )}
        </tr>
    );

    return (
        <table className='soloSearch_calendarTable'>
            <tbody>
                <tr>
                    <th className='soloSearch_calendarHeader'>
                        <Label label="プラン名" />
                    </th>
                    {cols}
                </tr>
                {cols2}
            </tbody>
        </table>
    );
}